export const PROVISIONING_STARTING_PAGE_SIZE = 10;
export const PROVISIONING_PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 250, 500, 1000];
